import api from '~/api';

export type inputType = {
    mvnFcId : string,
    ymd : string,
}

export type inputType1 = {
  mvnFcId: string,
  rsvtDay: string,
  rsvtBgngTm: string,
  rsvtEndTm: string,
  rsvtNope: number|null,
  utztnPurpose?: string
};

/** 시설예약 신청 요청 (MvnFcRsvtInsertParam) */
export type MvnFcRsvtInsertParam = {
  mvnFcId: string;
  rsvtDay: string;       // yyyyMMdd
  rsvtBgngTm: string;
  rsvtEndTm: string;
  rsvtNope: number;
  utztnPurpose: string;
  prkgYn: boolean;
  carNoList: string[];
  zip: string;
  addr: string;          // 기본주소 + 상세주소
  timeList: number[];
  /** 소속 */
  entrprsNm?: string;
  /** 사업자등록번호 */
  bizrno?: string;
  /** 이름 */
  memberNm?: string;
  /** 연락처 */
  cttpc?: string;
  /** 시간당금액 */
  rntfeeAmt?: number;
  /** 가산금액 */
  adamt?: number;
  /** 할인률 (%) */
  dscntRate?: number;
  /** 할인 ID (할인 적용 시) */
  dscntId?: string;
  /** 동의여부  */
  privacyAgreed?: boolean;
};

//공유시설 일자별 예약불가시간 목록 조회(PRG-USP-R04-02)
export default (data:inputType) => 
  api({
    method: 'get',
    url: `${process.env.REACT_APP_DOMAIN_MVN_BNET}/mvn/api/reservation/cutoff-time/${data.mvnFcId}`,
    params: data,
  });

// 시설예약 신청 POST /mvn/api/reservation/spaces
export const fetchReservationInsert = (data: MvnFcRsvtInsertParam) =>
  api({
    method: 'post',
    url: `${process.env.REACT_APP_DOMAIN_MVN_BNET}/mvn/api/reservation/spaces`,
    data,
  });

//사용자 입주현황 상세조회 (PRG-USP-IJH-02)
export const fetchMovinUser= (allInqireYn:boolean ) =>
  api({
    method: 'get',
    url: `${process.env.REACT_APP_DOMAIN_MVN_BNET}/mvn/api/status/movin-user`,
    params: allInqireYn,
  });

/** 입주회원 할인 정보 - 할인 목록은 항상 1개 */
export type MovinDiscountItem = {
  dscntId?: string;
  dscntResn?: string;
  dscntRate?: number;
  [key: string]: unknown;
};

/** 입주회원 여부 조회 - movinUser: true=입주회원( discountList 사용 ), false=비입주회원 */
export type MovinUserCheckResponse = {
  movinUser: boolean;
  discountList?: MovinDiscountItem[];
};

/** 입주기업 여부 조회. bizrno 전달 시 해당 사업자번호로 조회(수정 화면 등) */
export const fetchMovinUserCheck = (bizrno?: string): Promise<MovinUserCheckResponse> => {
  const baseUrl = `${process.env.REACT_APP_DOMAIN_MVN_BNET}/mvn/api/status/movin-user/check`;
  const url =
    bizrno != null && String(bizrno).trim() !== ''
      ? `${baseUrl}?bizrno=${encodeURIComponent(String(bizrno).trim())}`
      : baseUrl;
  return api({
    method: 'get',
    url,
  });
};

// 공휴일 받아오기
export const fetchHolidays = (ym:string) =>
  api({
    method: 'get',
    url: `${process.env.REACT_APP_DOMAIN_COMMON_BNET}/common/api/month-holidays/${ym}`,
  });